import styled from 'styled-components';

const HiddenInput = styled.input.attrs(() => ({ type: 'hidden' }))`
  display: none;
`;

export { HiddenInput };
